import React, { useContext } from "react";
import { CategoryContext } from "../../CategoryContext"; // Adjust path if needed
import "./AdDetailsFeatures.css";

const AdDetailsFeatures = ({ item_condition, category_id }) => {
    const categories = useContext(CategoryContext);

    // Resolve current category
    const currentCategory = categories.find(cat => cat.id === category_id);
    const parentCategory = currentCategory?.parent_id
        ? categories.find(cat => cat.id === currentCategory.parent_id)
        : null;

    const categoryDisplayName = parentCategory
        ? `${parentCategory.name} → ${currentCategory.name}`
        : currentCategory?.name || "Ni določeno";

    const productFeatures = [
        {
            title: "Stanje",
            description: item_condition || "Ni navedeno"
        },
        {
            title: "Kategorija",
            description: categoryDisplayName
        }
    ];

    return (
        <div className="item_features">
            <h5 className="features_title">⁍ Podrobnosti</h5>
            <div className="features_list d-flex flex-wrap">
                {productFeatures.map((feature, index) => (
                    <div
                        key={index}
                        className="feature d-flex"
                    >
                        <h6 className="feature_title">{feature.title}:</h6>
                        <p className="feature_description">{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdDetailsFeatures;